<template>
  <div>
    <div class="variable_container">
        <div>
            <InputField
                v-model="item.dynamic_variable.name"
                :placeholder="$t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.PLACEHOLDER_VAR_NAME')"
                type="text"
            />
        </div>
        <div>
            <MultiselectDropdown
                classNameLabel="llm_dropdown"
            >
                <!-- :error="$v.pathParams.$each[index].dynamic_variable.$error ? 'Required' : ''" -->
                    <!-- v-model="selectedOption" -->
                <multiselect
                    v-model="item.dynamic_variable"
                    class="column small-12"
                    :options="formatedOptions"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :placeholder="'Select dynamic variable'"
                    track-by="localValue"
                    label="localName"
                    @select="onSelect"
                />
            </MultiselectDropdown>
        </div>
    </div>
    <div>
        <InputField
            v-model="item.dynamic_variable.value"
            :placeholder="$t('CAMPAIGN.LLM_CHATBOT.ADD.DYNAMIC_VAR.PLACEHOLDER_VAR_VALUE')"
            type="text"
        />
    </div>
  </div>
</template>

<script>
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import InputField from 'components/ui/inputs/InputField.vue';

export default {
    components:{
        MultiselectDropdown,
        InputField,
    },
    props:{
        item:{
            type: Object,
            default:()=>({})
        },
        options:{
            type: Array,
            default:()=>([])
        },
    },
    data(){
        return{
            selectedOption: null,
        }
    },
    computed:{
        formatedOptions(){
            return this.options.map(el=>({...el,localName:el.name,localValue:el.value}))
        },
    },
    mounted(){
        // this.selectedOption = this.item.dynamic_variable
    },
    // watch:{
    //     'item.dynamic_variable': {
    //         handler(newVal) {
    //             const isValid = this.options.some(opt => opt.value === newVal?.value);
    //             this.selectedOption = isValid ? newVal : null;
    //         },
    //         immediate: true,
    //         deep: true,
    //     },
    // },
    methods:{
        onSelect(option){
            console.log(option);
            this.item.dynamic_variable = option;
        },
    },
}
</script>


<style scoped lang="scss">
.variable_container{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10;
}

</style>